import { Link } from 'react-router-dom'

export function NotFound(): JSX.Element {
  return (
    <main className="page page--centered">
      <h1>Not found</h1>
      <p className="muted">That page doesn&apos;t exist.</p>
      <Link className="button" to="/">
        Back to the gallery
      </Link>
    </main>
  )
}
